import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    gamesArray: [],
    total_number_of_games: 0
}

export const fetchGames = createAsyncThunk(
    'games/fetchGames',
    async (accessToken, thunkAPI) => {
        try {
            const gamesPromise = await fetch(process.env.REACT_APP_DATABASE_URL + '/games', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                mode: 'cors',
                credentials: 'include'
            });
            const games = await gamesPromise.json();
            return games;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.message);
        }
    }
);

export const gamesSlice = createSlice({
    name: 'games',
    initialState,
    reducers: {
        gameDeleted: (state, action) => {
            const temp_array = state.gamesArray.filter(game => game.id !== parseInt(action.payload));
            state.gamesArray = temp_array;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchGames.pending, (state, action) => {
        })
        .addCase(fetchGames.fulfilled, (state, action) => {
            const gamesData = action.payload;

            if(gamesData.success === true) {
                state.gamesArray = gamesData.list_games;
                state.total_number_of_games = gamesData.list_games.length;
            } else {
                alert(`Issue fetching games. Error: ${gamesData.code}. Description: ${gamesData.description}.`);
            }
        })
        .addCase(fetchGames.rejected, (state, action) => {
        })
    }
});

export const { gameDeleted } = gamesSlice.actions;
export default gamesSlice.reducer;
